module.exports = __webpack_public_path__ + "img/banner-farm.f52dbff8.png";